import { render, staticRenderFns } from "./UltimaAlteracao.vue?vue&type=template&id=4c3ee559&scoped=true&lang=pug"
import script from "./UltimaAlteracao.vue?vue&type=script&lang=js"
export * from "./UltimaAlteracao.vue?vue&type=script&lang=js"
import style0 from "./UltimaAlteracao.vue?vue&type=style&index=0&id=4c3ee559&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3ee559",
  null
  
)

export default component.exports